import { defineMessages } from "react-intl";

export const settingsOptionsMessages = defineMessages({
  "dict.settings.options.travelWillingness.NO": {
    id: "dict.settings.options.travelWillingness.NO",
    defaultMessage: "No",
  },
  "dict.settings.options.travelWillingness.WITHIN_CITY": {
    id: "dict.settings.options.travelWillingness.WITHIN_CITY",
    defaultMessage: "Yes – within city",
  },
  "dict.settings.options.travelWillingness.WITHIN_COUNTRY": {
    id: "dict.settings.options.travelWillingness.WITHIN_COUNTRY",
    defaultMessage: "Yes – within country",
  },
  "dict.settings.options.travelWillingness.WITHIN_REGION": {
    id: "dict.settings.options.travelWillingness.WITHIN_REGION",
    defaultMessage: "Yes – within region (e.g. DACH)",
  },
  "dict.settings.options.travelWillingness.WITHIN_EUROPE": {
    id: "dict.settings.options.travelWillingness.WITHIN_EUROPE",
    defaultMessage: "Yes – within Europe",
  },
  "dict.settings.options.travelWillingness.GLOBALLY": {
    id: "dict.settings.options.travelWillingness.GLOBALLY",
    defaultMessage: "Yes – globally",
  },
  "dict.settings.options.travelWillingness.OTHER": {
    id: "dict.settings.options.travelWillingness.OTHER",
    defaultMessage: "Other",
  },
  "dict.settings.options.deliveryFormat.ONLINE": {
    id: "dict.settings.options.deliveryFormat.ONLINE",
    defaultMessage: "Online",
  },
  "dict.settings.options.deliveryFormat.ONSITE": {
    id: "dict.settings.options.deliveryFormat.ONSITE",
    defaultMessage: "Onsite",
  },
  "dict.settings.options.deliveryFormat.HYBRID": {
    id: "dict.settings.options.deliveryFormat.HYBRID",
    defaultMessage: "Hybrid",
  },
  "dict.settings.options.deliveryFormat.OTHER": {
    id: "dict.settings.options.deliveryFormat.OTHER",
    defaultMessage: "Other",
  },
  "dict.settings.options.serviceType.ONE_TO_ONE": {
    id: "dict.settings.options.serviceType.ONE_TO_ONE",
    defaultMessage: "1-to-1",
  },
  "dict.settings.options.serviceType.EXECUTIVE": {
    id: "dict.settings.options.serviceType.EXECUTIVE",
    defaultMessage: "Executive",
  },
  "dict.settings.options.serviceType.TEAM": {
    id: "dict.settings.options.serviceType.TEAM",
    defaultMessage: "Team",
  },
  "dict.settings.options.serviceType.CAREER": {
    id: "dict.settings.options.serviceType.CAREER",
    defaultMessage: "Career",
  },
  "dict.settings.options.serviceType.GROUP": {
    id: "dict.settings.options.serviceType.GROUP",
    defaultMessage: "Group",
  },
  "dict.settings.options.serviceType.PEER_MENTORING": {
    id: "dict.settings.options.serviceType.PEER_MENTORING",
    defaultMessage: "Peer Mentoring",
  },
  "dict.settings.options.serviceType.WORKSHOPS": {
    id: "dict.settings.options.serviceType.WORKSHOPS",
    defaultMessage: "Workshops",
  },
  "dict.settings.options.serviceType.LONGER_PROGRAMS": {
    id: "dict.settings.options.serviceType.LONGER_PROGRAMS",
    defaultMessage: "Longer programs",
  },
  "dict.settings.options.serviceType.OTHER": {
    id: "dict.settings.options.serviceType.OTHER",
    defaultMessage: "Other",
  },
  "dict.settings.options.diagnosticTool.MBTI": {
    id: "dict.settings.options.diagnosticTool.MBTI",
    defaultMessage: "MBTI",
  },
  "dict.settings.options.diagnosticTool.GALLUP_STRENGTHSFINDER": {
    id: "dict.settings.options.diagnosticTool.GALLUP_STRENGTHSFINDER",
    defaultMessage: "Gallup StrengthsFinder",
  },
  "dict.settings.options.diagnosticTool.DISC": {
    id: "dict.settings.options.diagnosticTool.DISC",
    defaultMessage: "DISC",
  },
  "dict.settings.options.diagnosticTool.HOGAN": {
    id: "dict.settings.options.diagnosticTool.HOGAN",
    defaultMessage: "Hogan",
  },
  "dict.settings.options.diagnosticTool.LPI": {
    id: "dict.settings.options.diagnosticTool.LPI",
    defaultMessage: "LPI",
  },
  "dict.settings.options.diagnosticTool.FEEDBACK_360": {
    id: "dict.settings.options.diagnosticTool.FEEDBACK_360",
    defaultMessage: "360 Feedback",
  },
  "dict.settings.options.diagnosticTool.SHL": {
    id: "dict.settings.options.diagnosticTool.SHL",
    defaultMessage: "SHL",
  },
  "dict.settings.options.diagnosticTool.INSIGHTS_DISCOVERY": {
    id: "dict.settings.options.diagnosticTool.INSIGHTS_DISCOVERY",
    defaultMessage: "Insights Discovery",
  },
  "dict.settings.options.diagnosticTool.OTHER": {
    id: "dict.settings.options.diagnosticTool.OTHER",
    defaultMessage: "Other",
  },
  "dict.settings.options.industryExperience.TECH": {
    id: "dict.settings.options.industryExperience.TECH",
    defaultMessage: "Tech",
  },
  "dict.settings.options.industryExperience.FINANCE": {
    id: "dict.settings.options.industryExperience.FINANCE",
    defaultMessage: "Finance",
  },
  "dict.settings.options.industryExperience.PHARMA": {
    id: "dict.settings.options.industryExperience.PHARMA",
    defaultMessage: "Pharma",
  },
  "dict.settings.options.industryExperience.RETAIL": {
    id: "dict.settings.options.industryExperience.RETAIL",
    defaultMessage: "Retail",
  },
  "dict.settings.options.industryExperience.MANUFACTURING": {
    id: "dict.settings.options.industryExperience.MANUFACTURING",
    defaultMessage: "Manufacturing",
  },
  "dict.settings.options.industryExperience.LOGISTICS": {
    id: "dict.settings.options.industryExperience.LOGISTICS",
    defaultMessage: "Logistics",
  },
  "dict.settings.options.industryExperience.TELECOMMUNICATIONS": {
    id: "dict.settings.options.industryExperience.TELECOMMUNICATIONS",
    defaultMessage: "Telecommunications",
  },
  "dict.settings.options.industryExperience.PUBLIC_SECTOR": {
    id: "dict.settings.options.industryExperience.PUBLIC_SECTOR",
    defaultMessage: "Public Sector",
  },
  "dict.settings.options.industryExperience.GENERAL_CROSS_INDUSTRY": {
    id: "dict.settings.options.industryExperience.GENERAL_CROSS_INDUSTRY",
    defaultMessage: "General / Cross-Industry",
  },
  "dict.settings.options.industryExperience.OTHER": {
    id: "dict.settings.options.industryExperience.OTHER",
    defaultMessage: "Other",
  },
});
